var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery } from '@apollo/client/react';
import { useDebouncedCallback } from 'use-debounce';
import { SearchTypeEnum } from 'shared/domains/apollo/generated/types';
import { getAllMarketCodes, supportedMarketCodes } from 'shared/domains/markets/config';
import { AdvancedSearchDocument } from './AdvancedSearch.gql';
import { transformSearchQuery } from './transformSearchQuery';
export function useLazySearch() {
    const [fetchQuery, state] = useLazyQuery(AdvancedSearchDocument);
    const userMarketCodes = getAllMarketCodes();
    const excludedMarketCodes = supportedMarketCodes.filter((item) => !userMarketCodes.includes(item));
    const { error, loading, data } = state;
    const handleSearch = (query, modifiers) => __awaiter(this, void 0, void 0, function* () {
        const { searchType, searchFields, isFuzzy, onlyName } = modifiers;
        const variables = {
            modifiers: {
                searchType,
                isFuzzy,
                onlyName,
            },
            query,
            where: {
                marketCode: { notIn: excludedMarketCodes },
            },
            referrer: 'preview',
        };
        if (searchType !== SearchTypeEnum.AutocompleteName && variables.modifiers) {
            variables.modifiers.searchFields = searchFields;
        }
        return fetchQuery({
            query: AdvancedSearchDocument,
            fetchPolicy: 'no-cache',
            variables,
        });
    });
    const debouncedSearch = useDebouncedCallback((query, modifiers) => {
        if (query.length) {
            handleSearch(query, modifiers);
        }
    }, 250, { leading: true });
    return {
        search: debouncedSearch,
        data: transformSearchQuery(data),
        loading,
        error,
    };
}
